import { useDispatch } from 'react-redux';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { AxiosError } from 'axios';
import { apiClient } from '../../../utils/axios';

const updateShopifyConfig = async ({ payload }) => {
  const { data } = apiClient.patch(`/organizations/${payload.org_ref}/shopify/stores/${payload.shop_id}`, payload);
  return data;
};

export const useUpdateShopifyStoreHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);

  const mutation = useMutation({
    mutationFn: updateShopifyConfig,
    onSuccess: (data, variables, context) => {
      dispatch(showSnackbar({ message: 'Shopify configs updated successfully', severity: 'success' }));
      queryClient.invalidateQueries({ queryKey: ['shopify-stores'] });
      onSuccess && onSuccess(variables);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response.status === 400) {
          setError(error.response.data.errors);
          return;
        }
        dispatch(showSnackbar({ message: error.response.data, severity: 'error' }));
      }
      dispatch(showSnackbar({ message: error, severity: 'error' }));
    },
  });

  const onSave = async (data) => {
    const payload = { ...data };
    mutation.mutate({ payload });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSave: onSave,
  };
};
